import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DocxtemplateService {

  constructor(private http: HttpClient, private httpService: HttpService) { }
  addNoticeTemplate(templateData) {
    var request = {
      URL: 'addNoticeTemplate/',
      DATA: templateData
    }
    return this.httpService.post(request);
  }

  getDocxTemplates(companyId) {
    var request = {
      URL: 'getDocxTemplates/' + companyId,
    }
    return this.httpService.get(request);
  }

  addAgendaIndividualTemplate(templateData) {
    var request = {
      URL: 'addAgendaIndividualTemplate/',
      DATA: templateData
    }
    return this.httpService.post(request);
  }

  addMinuteTemplate(templateData) {
    var request = {
      URL: 'addMinuteTemplate/',
      DATA: templateData
    }
    return this.httpService.post(request);
  }

  addMinuteIndividualTemplate(templateData) {
    var request = {
      URL: 'addMinuteIndividualTemplate/',
      DATA: templateData
    }
    return this.httpService.post(request);
  }

}
